import axios from 'axios'
import type AccountStoreData from '@/types/AccountStoreData'
import type DocumentObject from '@/types/DocumentObject'
import type Mobility from '@/types/Mobility.interface'

export interface ApplicationPortfolioRenderData {
  account: AccountStoreData
  documents?: DocumentObject[]
  profileImageBase64?: string
  mobility?: Mobility
}

// In dev the frontend can be loaded via different hostnames (localhost for the
// browser, host.docker.internal for Browsershot running inside the backend
// container). Rewrite the API base URL's hostname to match the one that served
// the page so API calls are reachable from whichever context loaded us.
// Prod/non-prod use proper domains and go through the configured URL as-is.
const getApiBaseUrl = (): string => {
  const configured = import.meta.env.VITE_API_BASE_URL

  if (import.meta.env.DEV && typeof window !== 'undefined') {
    const url = new URL(configured)
    url.hostname = window.location.hostname
    return url.toString().replace(/\/$/, '')
  }

  return configured
}

class ApplicationPortfolioClient {
  async getRenderData(token: string): Promise<ApplicationPortfolioRenderData> {
    const { data } = await axios.get<ApplicationPortfolioRenderData>(
      `${getApiBaseUrl()}/v1/render/application-portfolio-data`,
      {
        headers: { Authorization: `Bearer ${token}` },
        timeout: 15000,
      },
    )
    return data
  }
}

export default new ApplicationPortfolioClient()
